import type { PaginationEventHandlersParams } from '@ksyos/design-system/dist/components/pagination/pagination';
import { useState } from 'react';

interface UsePaginationProps {
    defaultPageSize: number;
}

export function usePagination(props: UsePaginationProps) {
    const [paginationOptions, setPaginationOptions] = useState<PaginationEventHandlersParams & { totalItems: number }>({
        page: 1,
        pageSize: props.defaultPageSize,
        totalItems: 0,
    });

    const handlePaginationChange = (options: PaginationEventHandlersParams) => {
        setPaginationOptions((prev) => ({ ...prev, ...options }));
    };

    const handleTotalItemsChange = (totalItems: number) => {
        setPaginationOptions((prev) => ({ ...prev, totalItems }));
    };

    return { handlePaginationChange, handleTotalItemsChange, paginationOptions };
}
